import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import Modal from 'react-modal';
import { HARDWARE } from '../../../../constants/menu-types';
import {INPUT_IP_ELEMENT_SYSNAME} from '../../../../constants/element-type';
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import closeIcon from '../../../../images/close.svg';
import { UserPreferenceFilter } from '../../../../models/UserPreferenceFilter';
import { saveUserFilterPreferenceForIPRanges } from '../../../../services/userPreferenceService';
import { useDialog } from '../../../dialog/DialogContext';
import { toast } from "react-toastify";
import { AddIpRangeCard } from './AddIpRangeCard';

const initialValues = {
    startIp: "",
    endIp: ""
}

export const AddIpRangeModal = ({ isOpen, onclose }) => {
    const [formikContext, setFormikContext] = useState<any>();
    const { translate } = useLocale();
    const dialog = useDialog();

    const closeWizard = () => {
        formikContext.resetForm();
        onclose();
    };

    const onSave = async (values) => {
        const settingDataValue = values.startIp + ';' + values.endIp;
        const userPreferenceFilter: UserPreferenceFilter = {
            filterId: "13000",
            userLoginId: "1",
            currentMenuDetail: HARDWARE,
            filterData: [{
                filterTypeName: null,
                value: settingDataValue,
                elementSysname: INPUT_IP_ELEMENT_SYSNAME
            }],
            userPreference: "7"
        };

        await saveUserFilterPreferenceForIPRanges(userPreferenceFilter)
            .then(success => {
                toast.success(translate.byKey(TranslationKeys.ipRangeSaved));
            })
            .catch(failure => {
                const message = failure.message ? failure.message : translate.byKey(TranslationKeys.applicationError);
                dialog.pushError({ title: translate.byKey(TranslationKeys.error), message })
            });
        onclose();
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={closeWizard}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden" >
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={onSave}>
            <Form>
                <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                    <div className="flex flex-row">
                        <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.addRange)}</p>
                    </div>
                    <img src={closeIcon} onClick={onclose} className="cursor-pointer mr-2" />
                </div>
                <div className="pt-3 pl-8 pr-0" style={{ width: '400px' }} >
                    <AddIpRangeCard setFormikContext={setFormikContext} />
                </div>
                <div className="flex flex-row pb-3 pr-3 justify-end bg-white">
                    <div className="flex flex-row mt-4 mr-5">
                        <button
                            id='saveIpRangeBtnId'
                            className={`secondary secondary-enabled py-1 px-5`}
                            type="submit">
                            {translate.byKey(TranslationKeys.save)}
                        </button>
                    </div>
                </div>
            </Form>
        </Formik>
    </Modal>
};
